module.exports = __webpack_public_path__ + "img/Cheer Megaphone19.78ecf85b.jpg";